import { useEffect, useState } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { THEMES, type Theme, onThemeChange, readTheme, writeTheme } from '../lib/theme';
import { useT } from '../lib/i18n';

const ICON: Record<Theme, typeof Moon> = { dark: Moon, light: Sun, system: Monitor };

/**
 * Appearance, on every page, next to the language.
 *
 * Deliberately a plain <select> rather than a custom menu: it is reachable by
 * keyboard and by screen reader for free, it opens as the native picker on a
 * phone, and a grandparent recognises it. A hand-built dropdown would look a
 * little better and work a little worse.
 */
export function ThemeSwitcher() {
  const { t } = useT();
  const [theme, setTheme] = useState<Theme>(() => readTheme());
  useEffect(() => onThemeChange(setTheme), []);
  const Icon = ICON[theme];

  return (
    <label className="lang-chip" title={t('appearance.title')}>
      <Icon size={15} strokeWidth={1.75} aria-hidden="true" />
      <span className="sr-only">{t('appearance.label')}</span>
      <select
        value={theme}
        onChange={(e) => writeTheme(e.target.value as Theme)}
      >
        {THEMES.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {t(opt.key)}
          </option>
        ))}
      </select>
    </label>
  );
}
